module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_maedori@3x-4dc2176d17e417252257100fd037dda4.webp";